<div style="padding-bottom: 93px" class="st-drawer-wrapper flex flex-column gap-300">
  <a href=""></a>

  @if (nzData.service) {
    <!--  Header  -->
    <div class="st-drawer-header flex-center-between">
      <div class="flex-center gap-075">
        <span class="text-header-16 text-semibold text-nowrap">{{nzData.service.name}}</span>
        <a [href]="mainRoute + 'projects/detail/' + nzData.project?.id + '/service/' + nzData.service.id" target="_blank">
          <app-st-icon style="font-size: 16px" name="open_in_new"></app-st-icon>
        </a>
      </div>
      <app-st-icon class="text-header-16" style="cursor: pointer" (click)="close()" name="close"></app-st-icon>
    </div>

    <div class="st-drawer-content">
      <!-- Key-value List for editing -->
      <app-list-key-value [keysWidth]="{value: 160, unit: 'px'}"
                          [innerRowGap]="{value: 16, unit: 'px'}"
                          [innerColumnGap]="{value: 16, unit: 'px'}"
                          [outterColumnGap]="{value: 32, unit: 'px'}"
                          [outterColumns]="1"
                          [autoSave]="false"
                          [data]="setKeyValueData()"></app-list-key-value>

      <!-- Service Detail Content -->
      <app-service-detail-main (isDocDrawerOpen)="docDrawerChange($event)"
                               [overflowAuto]="false"
                               [padding]="false"
                               [service]="nzData.service"></app-service-detail-main>
    </div>

    <!-- Footer with save button -->
    <div class="st-drawer-footer">
      <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="close()" >
        Cancelar
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="saveService()" >
        Guardar
      </button>
    </div>

  }
</div>

<!-- Notification Template -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>